import React from 'react'

export const userTable = (handleEdit, handleIsActive) => {
    return [
        {
            title: "id_user",
            render: rowData => {
                return <span>{rowData.id_user}</span>
            }
        },
        {
            title: "Nama User",
            render: rowData => {
                return <span>{rowData.nama_user}</span>
            }
        },
        {
            title: "Email",
            render: rowData => {
                return <span>{rowData.email}</span>
            }
        },
        {
            title: "No Hp",
            render: rowData => {
                return <span>{rowData.no_hp}</span>
            }
        },
        {
            title: "Role",
            render: rowData => {
                return <span>{rowData.role}</span>
            }
        },
        {
            title: "Is Active",
            render: rowData => {
                return <span>{rowData.is_active === '1' ? "Aktif" : "Tidak Aktif"}</span>
            }
        },
        {
            title: "Created At",
            render: rowData => {
                return <span>{rowData.created_at}</span>
            }
        }, 
        {
            title: "Updated At",
            render: rowData => {
                return <span>{rowData.updated_at}</span>
            }
        },
        {
            title : "Action",
            render : rowData => {
                return (
                    <>
                        <button 
                            className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded mr-2"
                            onClick={(e) => handleEdit(rowData)}
                        >
                        Edit
                        </button>
                        <button 
                            className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded mr-2"
                            onClick={(e) => handleIsActive(rowData)}
                        >
                        Change Status
                        </button>
                    </>
                )
            }
        }
    ]
}